import React from "react";
import { connect } from "react-redux";
import language from "../../language/index.js";
import { Table } from "../Table/index.js";
import { CSVLink } from "react-csv";
import requestQuery, {
  deleteRequest,
  getBloodRequestDashboardCounts,
} from "../../utils/queries/requestQuery.js";
import { fetchRequestedProducts } from "../../utils/queries/request-product.js";
import { fetchPatients } from "../../utils/queries/patient.js";
import exportPDF from "../../utils/exportPDF.js";
import { DeleteModal, Modal } from "../Modal/index.js";
import { getStorage } from "../../utils/storage.js";
import RequestInfo from "./nominative/RequestInfo.js";
import icons from "../../constants/icons.js";
import accessMenu from "../../utils/accessMenu/index.js";
import Input from "../Input/Input.js";
import { Select } from "../Input/index.js";
import Button from "../Button/Button.js";
import api from "../../utils/api/index.js";
import toastMessage from "../../utils/toastMessage.js";
import CardCount from "../CardCount/CardCount.js";
import normalizeRequestDashboardCounts from "../../utils/normalizeRequestDashboardCounts.js";
let API_URL = process.env.REACT_APP_BBMS_BASE_API;

class MyRequests extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selected_data: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    counts: {},
    isLoadingCounts: false,
    totalRecords: 0,
    showCountDetailsModal: false,
    countDetailsType: "",
    countDetailsTitle: "",
    isLoadingCountDetails: false,
    countDetailsData: [],
    countDetailsPage: 1,
    countDetailsLimit: 10,
    countDetailsTotalRecords: 0,
    countDetailsTotalPageCount: 0,
    countDetailsSearchText: "",
    searchingCountDetails: false,
    selectedPatient: null,
  
    cancelReason: "",
};

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  returnFilters = async (search) => {
    const user = await getStorage();
    const { page, limit } = this.state;
    const { status, type } = this.props;
    const isDonationScoped = !!(
      this.props?.donationId || this.props?.donationNumber
    );

    console.log("User info in filters:", type);

    // const canNominativeRequest = defineRole({
    //   roles: this.state.user.accessRole,
    //   menu: ROLE_NOMINATIVE_REQUEST,
    //   operation: "read",
    // });

    // const canBulkRequest = defineRole({
    //   roles: this.state.user.accessRole,
    //   menu: ROLE_BULK_REQUEST,
    //   operation: "read",
    // });

    // if (canNominativeRequest && canBulkRequest) {
    //   type = null;
    // } else if (canNominativeRequest) {
    //   type = "nominative";
    // } else if (canBulkRequest) {
    //   type = "bulk";
    // }

    return {
      page: isDonationScoped ? 1 : page,
      limit: isDonationScoped ? 200 : limit,
      status,
      ...search,
      stock: user.stock,
      hospital: user.hospital?._id || user.hospital,
      type,
    };
  };

  filterRequestsByDonationReference = async (requests = []) => {
    const donationId = this.props?.donationId;
    const donationNumber = (this.props?.donationNumber || "")
      .trim()
      .toLowerCase();

    if (!donationId && donationNumber === "") {
      return requests;
    }

    const checks = await Promise.all(
      requests.map(async (request) => {
        const response = await fetchRequestedProducts(this.props.defaultLanguage, {
          request: request?._id,
          page: 1,
          limit: 200,
        });

        const products = response?.data || [];
        const matches = products.some((product) => {
          const donation = product?.inventory?.donation;
          const productDonationId = donation?._id || donation;
          const productDonationNumber = (
            donation?.donationNumber || ""
          ).toLowerCase();

          return (
            (donationId &&
              productDonationId &&
              String(productDonationId) === String(donationId)) ||
            (donationNumber !== "" && productDonationNumber === donationNumber)
          );
        });

        return matches ? request : null;
      })
    );

    return checks.filter(Boolean);
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;
      const filters = await this.returnFilters(search);

      this.setState({ isLoading, isLoadingCounts: true });

      const [listResponse, counts] = await Promise.all([
        requestQuery(defaultLanguage, filters),
        getBloodRequestDashboardCounts(defaultLanguage, filters),
      ]);

      const { data, count, totalRecords } = listResponse || {};

      const filteredData = await this.filterRequestsByDonationReference(
        data || []
      );
      const isDonationScoped = !!(
        this.props?.donationId || this.props?.donationNumber
      );
      const resolvedTotalRecords = isDonationScoped
        ? filteredData.length
        : typeof totalRecords === "number"
          ? totalRecords
          : (count || 0) * this.state.limit;

      const normalizedCounts = normalizeRequestDashboardCounts(counts);

      this.setState({
        data: filteredData,
        totalPageCount: totalRecords,
        totalRecords: resolvedTotalRecords,
        counts: normalizedCounts,
        isLoading: false,
        isLoadingCounts: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        isLoadingCounts: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleLimitChange = (newLimit) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      this.getData(true);
    });
  };

  getCountDetailsTotal = (countType) => {
    if (countType === "initiated") return this.state.counts?.initiated || 0;
    if (countType === "pending") return this.state.counts?.pending || 0;
    if (countType === "inProgress") return this.state.counts?.inProgress || 0;
    if (countType === "received") return this.state.counts?.received || 0;
    if (countType === "cancelled") return this.state.counts?.cancelled || 0;
    return this.state.counts?.total || 0;
  };

  getCountDetailsStatusFilter = (countType) => {
    if (countType === "initiated") return "initiated";
    if (countType === "pending") return "pending";
    if (countType === "inProgress") {
      return [
        "pending",
        "samplecollected",
        "tested",
        "requestreceived",
        "processing",
      ];
    }
    if (countType === "received") return "received";
    if (countType === "cancelled") return "cancelled";
    return undefined;
  };

  getCountDetailsData = async (
    isLoadingCountDetails,
    page = this.state.countDetailsPage,
    countType = this.state.countDetailsType,
    searchText = this.state.countDetailsSearchText,
  ) => {
    try {
      const { defaultLanguage } = this.props;
      const limit = this.state.countDetailsLimit;

      this.setState({ isLoadingCountDetails });

      const status = this.getCountDetailsStatusFilter(countType);
      const filters = await this.returnFilters({
        status,
        requestNo:
          searchText && `${searchText}`.trim() !== ""
            ? `${searchText}`.trim()
            : undefined,
      });

      const response = await requestQuery(defaultLanguage, {
        ...filters,
        page,
        limit,
      });

      const data = response?.data || [];
      const totalRecords =
        response?.totalRecords ?? this.getCountDetailsTotal(countType);
      const totalPages = Math.max(Math.ceil((totalRecords || 0) / limit), 1);

      this.setState({
        countDetailsData: data,
        countDetailsPage: page,
        countDetailsTotalRecords: totalRecords,
        countDetailsTotalPageCount: totalPages,
        isLoadingCountDetails: false,
        searchingCountDetails: false,
      });
    } catch (error) {
      this.setState({
        isLoadingCountDetails: false,
        searchingCountDetails: false,
      });
    }
  };

  handleCountDetailsOpen = (countType, countTitle) => {
    const totalRecords = this.getCountDetailsTotal(countType);
    const limit = this.state.countDetailsLimit;

    this.setState(
      {
        showCountDetailsModal: true,
        countDetailsType: countType,
        countDetailsTitle: countTitle,
        countDetailsData: [],
        countDetailsPage: 1,
        countDetailsTotalRecords: totalRecords,
        countDetailsTotalPageCount: Math.max(
          Math.ceil((totalRecords || 0) / limit),
          1,
        ),
        countDetailsSearchText: "",
        searchingCountDetails: false,
      },
      () => this.getCountDetailsData(true, 1, countType),
    );
  };

  handleCountDetailsClose = () => {
    this.setState({
      showCountDetailsModal: false,
      countDetailsType: "",
      countDetailsTitle: "",
      isLoadingCountDetails: false,
      countDetailsData: [],
      countDetailsPage: 1,
      countDetailsTotalRecords: 0,
      countDetailsTotalPageCount: 0,
      countDetailsSearchText: "",
      searchingCountDetails: false,
    });
  };

  handleCountDetailsPagination = (page) => {
    this.getCountDetailsData(true, page);
  };

  handleCountDetailsSearch = (e) => {
    this.setState({
      countDetailsSearchText: e?.target?.value || "",
    });
  };

  handleCountDetailsRemoteSearch = async () => {
    this.setState({
      searchingCountDetails: true,
    });

    await this.getCountDetailsData(
      true,
      1,
      this.state.countDetailsType,
      this.state.countDetailsSearchText,
    );
  };

  getCountDetailsModalTitle = () => {
    const baseTitle = this.state.countDetailsTitle || "";
    const total = this.state.countDetailsTotalRecords || 0;
    return `${baseTitle} (${total})`;
  };

  returnCountDetailsHeaders = () => {
    const { defaultLanguage } = this.props;

    return [
      {
        title: language[defaultLanguage].request_number,
        key: "requestNo",
        type: "link",
        styles: {
          textTransform: "uppercase",
        },
        onPress: (item) =>
          (window.location.href =
            item.type === "bulk"
              ? `/dashboard/request/bulk/${item.requestNo}`
              : `/dashboard/request/${item.requestNo}`),
      },
      {
        title: language[defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[defaultLanguage].requested_by,
        key: "hospital.name",
      },
      {
        title: language[defaultLanguage].type,
        key: "type",
      },
      {
        title: language[defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[defaultLanguage].account,
        key: "account.pin",
      },
    ];
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].request_number,
        key: "requestNo",
        type: "link",
        styles: {
          textTransform: "uppercase",
        },
        copyEnabled: true,
        onPress: (item) =>
          (window.location.href =
            item.type === "bulk"
              ? `/dashboard/request/bulk/${item.requestNo}`
              : `/dashboard/request/${item.requestNo}`),
      },
      ...(this.props.type === "nominative"
        ? [
            {
              title: language[this.props.defaultLanguage].patient_id,
              key: "patient.patientId",
            },
            {
              title: (language[this.props.defaultLanguage].patient || "Patient") + " Names",
              key: "patient",
              render: (item) => {
                const first = item?.patient?.firstName || "";
                const last = item?.patient?.lastName || "";
                return (first + " " + last).trim() || "-";
              },
            },
          ]
        : []),
      {
        title: language[this.props.defaultLanguage].request_date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",

        // type: "link",
        onPress: (item) =>
          (window.location.href =
            item.type === "bulk"
              ? `/dashboard/request/bulk/${item.requestNo}`
              : `/dashboard/request/${item.requestNo}`),
      },
      {
        title: language[this.props.defaultLanguage].hospital,
        key: "hospital.name",
      },
      ...(this.props.type === "nominative"
        ? [
            {
              title: language[this.props.defaultLanguage].service,
              key: "patientHospitalization.service.name",
            },
            {
              title: language[this.props.defaultLanguage].room_number,
              key: "patientHospitalization.roomNumber",
            },
            {
              title: language[this.props.defaultLanguage].bed_number,
              key: "patientHospitalization.bedNumber",
            },
          ]
        : []),
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].requester,
        key: "account.name",
      },
      {
        title: language[this.props.defaultLanguage].reason,
        key: "reason",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { defaultLanguage } = this.props;

      const { data } = await requestQuery(
        defaultLanguage,
        await this.returnFilters()
      );

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await requestQuery(
      defaultLanguage,
      await this.returnFilters()
    );

    this.setState({
      isLoading: false,
    });

    exportPDF("Requests", headers, data);
  };

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteRequest(
        this.props.defaultLanguage,
        this.state.selected_data._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      q: search || undefined,
    });

    this.setState({
      searching: false,
    });
  };

  loadPatientOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return [];
    try {
      const { defaultLanguage } = this.props;
      const results = await fetchPatients(defaultLanguage, {
        q: inputValue.trim(),
        limit: 15,
      });
      const list = Array.isArray(results) ? results : results?.data || [];
      return list.map((p) => ({
        label: `${p.firstName || ""} ${p.lastName || ""}`.trim() + (p.patientBBMSNumber ? ` (${p.patientBBMSNumber})` : ""),
        value: p._id,
      }));
    } catch {
      return [];
    }
  };

  handlePatientSelect = (selected) => {
    this.setState({ selectedPatient: selected }, () => {
      this.getData(true, selected ? { patient: selected.value } : {});
    });
  };

  handleCancelRequest = async (item) => {
    const isSuperAdmin = this.state.user?.role === "superAdmin";
    if (
      !isSuperAdmin &&
      ((item.status !== "pending" &&
        item?.status !== "initiated" &&
        item.type !== "nominative") ||
        item.status === "cancelled")
    ) {
      toastMessage("error", language[this.props.defaultLanguage].cannot_cancel);
      return;
    }
    if (item.status === "cancelled") {
      toastMessage("error", language[this.props.defaultLanguage].cannot_cancel);
      return;
    }

    this.handleShowModal(
      "showCancelRequest",
      language[this.props.defaultLanguage].cancel,
      item
    );
  };

  onCancelRequest = async () => {
    try {
      this.setState({ isCancelling: true });

      const { selected_data, cancelReason } = this.state;

      if (!cancelReason) {
        return;
      }

      let options = {};

      if (
        selected_data.status === "pending" ||
        selected_data?.status === "initiated"
      ) {
        options = {
          url: `${API_URL}/bloodrequest`,
          method: "PUT",
          data: {
            id: selected_data._id,
            reason: cancelReason,
            status: "cancelled",
          },
        };
      } else if (
        selected_data.type === "nominative" &&
        selected_data?.status !== "cancelled"
      ) {
        options = {
          url: `${API_URL}/bloodrequest/cancel`,
          method: "POST",
          data: {
            id: selected_data._id,
            cancellationReason: cancelReason,
          },
        };
      }

      await api(options);

      this.setState({ isCancelling: false });

      this.getData(true);
      this.handleCloseModal("showCancelRequest");
    } catch (error) {
      toastMessage("error", error);

      this.setState({
        isCancelling: false,
      });
    }
  };

  render() {
    const { delete_request, delete_, cancel, view } =
      language[this.props.defaultLanguage];

    const { canReadBloodRequestAccess, canDeleteBloodRequestAccess } =
      accessMenu();

    const isSuperAdmin = this.state.user?.role === "superAdmin";

    let actions = [
      {
        canAccess: canReadBloodRequestAccess,

        name: view,
        onPress: (item) =>
          (window.location.href =
            item.type === "bulk"
              ? `/dashboard/request/bulk/${item.requestNo}`
              : `/dashboard/request/${item.requestNo}`),
        icon: icons.eye_on,
      },
      {
        canAccess: canReadBloodRequestAccess,

        name: cancel,
        onPress: (item) => {
          this.handleCancelRequest(item);
        },
        icon: icons.close,
        isHidden: (item) =>
          isSuperAdmin
            ? false
            : item?.status?.toUpperCase() === "PENDING" &&
              item?.account?._id === this.state?.user?.id
            ? false
            : !canDeleteBloodRequestAccess,
      },
    ];

    actions.push({
      canAccess: true,
      name: delete_,
      onPress: this.handleShowModal.bind(
        this,
        "showDeleteModal",
        delete_request,
      ),
      isHidden: (item) =>
        isSuperAdmin
          ? false
          : item?.status?.toUpperCase() === "PENDING" &&
            item?.account?._id === this.state?.user?.id
          ? false
          : !canDeleteBloodRequestAccess,
      icon: icons.delete,
    });

    return (
      <>
        <div className="row mb-3">
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].total}
              count={this.state.counts?.total || 0}
              isLoading={this.state.isLoadingCounts}
              color="#1f8ef1"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "total",
                  language[this.props.defaultLanguage].total,
                )
              }
            />
          </div>
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].initiated}
              count={this.state.counts?.initiated || 0}
              isLoading={this.state.isLoadingCounts}
              color="#17a2b8"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "initiated",
                  language[this.props.defaultLanguage].initiated,
                )
              }
            />
          </div>
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].pending}
              count={this.state.counts?.pending || 0}
              isLoading={this.state.isLoadingCounts}
              color="#f0ad4e"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "pending",
                  language[this.props.defaultLanguage].pending,
                )
              }
            />
          </div>
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].processing}
              count={this.state.counts?.inProgress || 0}
              isLoading={this.state.isLoadingCounts}
              color="#6f42c1"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "inProgress",
                  language[this.props.defaultLanguage].processing,
                )
              }
            />
          </div>
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].received}
              count={this.state.counts?.received || 0}
              isLoading={this.state.isLoadingCounts}
              color="#20c997"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "received",
                  language[this.props.defaultLanguage].received,
                )
              }
            />
          </div>
          <div className="col-md-2 col-sm-4 col-6 mb-2">
            <CardCount
              title={language[this.props.defaultLanguage].cancelled}
              count={this.state.counts?.cancelled || 0}
              isLoading={this.state.isLoadingCounts}
              color="#dc3545"
              onPress={() =>
                this.handleCountDetailsOpen(
                  "cancelled",
                  language[this.props.defaultLanguage].cancelled,
                )
              }
            />
          </div>
        </div>

        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange}
          headers={this.returnTableHeaders()}
          actions={actions}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showRequest")}
          show={this.state.showRequest}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <RequestInfo
            handleCloseModal={this.handleCloseModal.bind(this, "showRequest")}
            data={this.state.selected_data}
            getData={this.getData.bind(this, true)}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showCancelRequest")}
          show={this.state.showCancelRequest}
          title={this.state.modalTitle}
        >
          <div className="card-body">
            <Input
              label={language[this.props.defaultLanguage].reason}
              value={this.state.cancelReason}
              onChange={(e) => this.onChangeText("cancelReason", e)}
            />
            <Button
              text={language[this.props.defaultLanguage].submit}
              onPress={this.onCancelRequest.bind(this)}
              isSubmitting={this.state.isCancelling}
            />
          </div>
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          {isSuperAdmin ||
          (this.state.selected_data.status === "pending" &&
            canDeleteBloodRequestAccess &&
            this.state.selected_data?.hospital?._id ===
              this.state.user?.hospital) ||
          (this.state.selected_data.status === "pending" &&
            this.state.selected_data?.account?._id === this.state.user.id) ? (
            <DeleteModal
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showDeleteModal"
              )}
              error={this.state.error.delete_password}
              value={this.state.delete_value}
              onDelete={this.onDelete.bind(this)}
              onChange={(e) => this.onChangeText("delete_value", e)}
              isDeleting={this.state.isDeleting}
              name={this.state.selected_data.name}
              getData={this.getData.bind(this)}
            />
          ) : (
            <center className="card-body">
              No allowed to delete this request
            </center>
          )}
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"BloodRequests" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
        <Modal
          handleClose={this.handleCountDetailsClose}
          show={this.state.showCountDetailsModal}
          title={this.getCountDetailsModalTitle()}
          size="xl"
        >
          <div className="card-body">
            <Table
              data={this.state.countDetailsData}
              isSearch
              page={this.state.countDetailsPage}
              limit={this.state.countDetailsLimit}
              search_text={this.state.countDetailsSearchText}
              handleSearch={this.handleCountDetailsSearch}
              addSearchButton
              searching={this.state.searchingCountDetails}
              handlePressSearch={this.handleCountDetailsRemoteSearch}
              totalPageCount={this.state.countDetailsTotalPageCount}
              totalRecords={this.state.countDetailsTotalRecords}
              isLoading={this.state.isLoadingCountDetails}
              handlePagination={this.handleCountDetailsPagination}
              headers={this.returnCountDetailsHeaders()}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(MyRequests);
